<template>
  <v-container>
    <v-card class="px-2">
      <input
        id="user-id"
        type="hidden"
        v-model="noticia.usuario"
      />
      <input
        id="noticia-id"
        type="hidden"
        v-model="noticia.id"
      />
      <input
        id="noticia-uuid"
        type="hidden"
        v-model="noticia.uuid"
      />
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            outlined
            dense
            @change="loadUpdate()"
          >
            <v-btn
              class="btn-outer-right-1 pa-0"
              slot="append-outer"
              color="success"
              tile
              @click.prevent="loadDialog"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-autocomplete
            v-model="noticia.uid_categoria"
            :items="categorias"
            hide-selected
            dense
            outlined
            @blur="loadSubCategorias()"
            label="Categoria da notícia"
          >
            <v-icon
              class="mr-2"
              slot="append"
              color="black"
              v-if="noticia.uid_categoria"
              @click.prevent="limparBoxes()"
            >
              mdi-close
            </v-icon>
            <v-btn
              class="btn-outer  ml-2 pa-0"
              slot="append"
              color="success"
              tile
              @click="dialogCategoria"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
            <v-btn
              class="btn-outer-right pa-0"
              slot="append"
              color="light"
              tile
              :disabled="Boolean(noticia.uid_categoria)"
              @click="loadAddCategoria"
            >
              <v-icon
                class="mx-0"
                color="black"
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-autocomplete
            v-model="noticia.uid_subcategoria"
            :items="subcategorias"
            clearable
            dense
            outlined
            label="Subcategoria da notícia"
            :disabled="!noticia.uid_categoria"
          >
            <v-btn
              class="btn-outer pa-0"
              slot="append"
              color="success"
              tile
              @click="dialogCategoria"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
            <v-btn
              class="btn-outer-right pa-0"
              slot="append"
              color="light"
              tile
              @click="loadAddSubCategoria"
            >
              <v-icon
                class="mx-0"
                color="black"
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="8"
        >
          <v-text-field
            v-model="noticia.titulo"
            label="Título"
            outlined
            required
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="8"
        >
          <v-text-field
            v-model="noticia.slug"
            label="Slug"
            outlined
            required
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="8"
        >
          <v-textarea
            v-model="noticia.subtitulo"
            label="Subtítulo"
            auto-grow
            outlined
            rows="3"
            row-height="25"
            dense
          ></v-textarea>
        </v-col>
      </v-row>
      <v-card>
        <v-tabs
          v-model="tabs"
          height="45"
        >
          <v-tab>
            <v-icon class="mr-1">
              mdi-cog-sync
            </v-icon>
            Carga
          </v-tab>
          <v-tab>
            <v-icon class="mr-2">
              mdi-note-text
            </v-icon>
            Texto
          </v-tab>
          <v-tab :disabled="!noticia.id">
            <v-icon class="mr-2">
              mdi-settings
            </v-icon>
            Configurações
          </v-tab>
          <v-tab
            @click="loadGalerias"
            :disabled="!noticia.id"
          >
            <v-icon class="mr-2">
              mdi-folder-multiple-image
            </v-icon>
            Galerias
          </v-tab>
          <v-tab
            @click="loadMidias"
            :disabled="!noticia.id"
          >
            <v-icon class="mr-2">
              mdi-image-plus
            </v-icon>
            Imagens
          </v-tab>
          <v-tab
            @click="loadDocs"
            :disabled="!noticia.id"
          >
            <v-icon class="mr-2">
              mdi-paperclip
            </v-icon>
            Arquivos
          </v-tab>
          <v-tab
            @click="loadPubConteudo()"
            :disabled="!noticia.id"
          >
            <v-icon class="mr-2">
              mdi-eye
            </v-icon>
            Publicação
          </v-tab>
          <v-tab
            @click="loadUnidadesViculadas()"
            :disabled="!noticia.id"
          >
            <v-icon class="mr-2">
              mdi-home-city
            </v-icon>
            Unidades
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col cols="12" md="12" class="py-8">
                    Cargar dados da API Prodata<v-spacer class="ml-6"></v-spacer><span class="text-red-lighten-1">Atenção para realizar esta operação os campos dada e ano de referencia são obrigatórios</span>
                    <v-card>
                      <v-container>
                        <v-form>
                          <v-row>
                            <v-col cols="12" md="3" lg="4">
                              <v-text-field v-model="sync.tipo" required dense outlined
                                label="Tipo de dados"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="mt-1">
                            <v-col cols="12" md="6">
                              <v-btn color="success" class="ml-1 mr-4" @click="syncDados">
                                <v-icon left>
                                  mdi-table-sync
                                </v-icon>
                                Carregar
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card>
                  </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card class="pa-2">
                    <ckeditor
                      :editor="editor"
                      v-model="noticia.content"
                      :config="editorConfig"
                      placeholder="Conteúdo ..."
                    ></ckeditor>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                  v-if="noticia.id"
                >
                  <v-checkbox
                    v-model="noticia.inativar"
                    label="Inativar notícia ?"
                    color="success"
                  >
                  </v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-checkbox
                    v-model="noticia.externa"
                    label="Notícia externa?"
                    color="success"
                    hide-details
                  >
                  </v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-checkbox
                    v-model="noticia.destacar"
                    label="Destacar na sessão?"
                    color="success"
                    hide-details
                  >
                  </v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-checkbox
                    v-model="noticia.destacar_pag_principal"
                    label="Destacar no slide?"
                    color="success"
                    hide-details
                  >
                  </v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  v-if="noticia.id"
                >
                  <v-checkbox
                    v-model="url.omitir_titulo_slide"
                    label="Omitir título do slide?"
                    color="success"
                  >
                  </v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  v-if="noticia.id"
                >
                  <v-checkbox
                    v-model="url.aviso"
                    label="Ativar popup?"
                    color="success"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model="noticia.url_page"
                        label="Url para uma página externa"
                        outlined
                        required
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-autocomplete
                        v-model="noticia.target_url"
                        :items="targets"
                        required
                        dense
                        outlined
                        label="Target"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="noticia.url_slide"
                        label="Foto do slide"
                        outlined
                        required
                        dense
                      >
                        <v-btn
                          v-if="!noticia.url_slide"
                          class="btn-outer-left pa-0"
                          slot="append"
                          color="success"
                          tile
                          @click.prevent="loadAddImg(box='slide')"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-upload-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="noticia.url_slide"
                          class="btn-outer-left pa-0"
                          slot="append"
                          color="warning"
                          tile
                          @click.prevent="loadDelSlide()"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-delete-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="noticia.url_slide"
                          class="btn-outer-right-1 pa-0"
                          slot="append-outer"
                          color="success"
                          tile
                          @click.prevent="verFoto( tp='slide' )"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-eye-outline
                          </v-icon>
                        </v-btn>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="noticia.url_imagem"
                        label="Foto de capa"
                        outlined
                        required
                        dense
                      >
                        <v-btn
                          v-if="!noticia.url_imagem"
                          class="btn-outer-left pa-0"
                          slot="append"
                          color="success"
                          tile
                          @click.prevent="loadAddImg(box='capa')"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-upload-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="noticia.url_imagem"
                          class="btn-outer-left pa-0"
                          slot="append"
                          color="warning"
                          tile
                          @click.prevent="loadDelCapa()"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-delete-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="noticia.url_imagem"
                          class="btn-outer-right-1 pa-0"
                          slot="append-outer"
                          color="success"
                          tile
                          @click.prevent="verFoto( tp='capa' )"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-eye-outline
                          </v-icon>
                        </v-btn>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="noticia.url_video"
                        label="Video principal"
                        outlined
                        required
                        dense
                      >
                        <v-btn
                          v-if="!noticia.url_video"
                          class="btn-outer-left pa-0"
                          slot="append"
                          color="success"
                          tile
                          @click.prevent="loadAddImg(box='capa')"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-upload-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="noticia.url_video"
                          class="btn-outer-left pa-0"
                          slot="append"
                          color="warning"
                          tile
                          @click.prevent="loadDelVideo()"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-delete-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="noticia.url_video"
                          class="btn-outer-right-1 pa-0"
                          slot="append-outer"
                          color="success"
                          tile
                          @click.prevent="verFoto( tp='video' )"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-eye-outline
                          </v-icon>
                        </v-btn>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="noticia.url_Thumbnail"
                        label="Thumbnail do video"
                        outlined
                        required
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="noticia.url_aviso"
                        label="Url da imagem de popup"
                        outlined
                        required
                        dense
                      >
                        <v-btn
                          v-if="!noticia.url_aviso"
                          class="btn-outer-left pa-0"
                          slot="append"
                          color="success"
                          tile
                          @click.prevent="loadAddImg(box='popup')"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-upload-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="noticia.url_aviso"
                          class="btn-outer-left pa-0"
                          slot="append"
                          color="warning"
                          tile
                          @click.prevent="loadDelPopup()"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-delete-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="noticia.url_aviso"
                          class="btn-outer-right-1 pa-0"
                          slot="append-outer"
                          color="success"
                          tile
                          @click.prevent="verFoto( tp='popup' )"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-eye-outline
                          </v-icon>
                        </v-btn>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-card
                    class="pa-2"
                    v-if="fotoView"
                  >
                    <v-img :src="fotoView">
                    </v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-container>
                <v-card>
                  <v-card-title>
                    Galerias de imagens ou videos
                  </v-card-title>
                  <v-data-table
                    :headers="headersGaleria"
                    :items="galerias"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        large
                        color="success"
                        class="mr-2"
                        @click="loadPageGalery(item)"
                      >
                        mdi-image-move
                      </v-icon>
                      <v-icon
                        large
                        color="success"
                        class="mr-2"
                        @click="loadGaleriaUp(item)"
                      >
                        mdi-square-edit-outline
                      </v-icon>
                    </template>
                  </v-data-table>
                  <v-card-actions class="justify-end">
                    <v-btn
                      color="success"
                      class="ml-4 mb-2"
                      v-if="noticia.id"
                      @click="loadAddGalery"
                    >
                      <v-icon left>
                        mdi-camera
                      </v-icon>
                      Criar Galeria
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card>
                    <v-card-title>
                      Imagens
                    </v-card-title>
                    <v-data-table
                      :headers="headersFoto"
                      :items="fotos"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          large
                          color="success"
                          class="mr-2"
                          @click="loadUrl(item)"
                        >
                          mdi-upload-network
                        </v-icon>
                        <v-icon
                          large
                          color="success"
                          class="mr-2"
                          @click="loadFoto(item)"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="success"
                        class="ml-4 mb-2"
                        v-if="noticia.id"
                        @click="loadAddFoto"
                      >
                        <v-icon left>
                          mdi-camera
                        </v-icon>
                        Adicionar imagem
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card>
                    <v-card-title>
                      Documentos anexados
                    </v-card-title>
                    <v-data-table
                      :headers="headersAnexos"
                      :items="anexos"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              medium
                              color="error"
                              class="mr-2"
                              @click="removeAnexo(item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Desvincular anexo da notícia</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                        lg="1"
                      >
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="noticia.id"
                          @click="loadAddDoc"
                        >
                          <v-icon left>
                            mdi-arrow-up-bold-box-outline
                          </v-icon>
                          Upload
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        lg="1"
                      >
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="noticia.id"
                          @click="loadDAnexo"
                        >
                          <v-icon left>
                            mdi-paperclip
                          </v-icon>
                          Anexar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-container>
                <v-card>
                  <v-card-title>
                    Unidades vinculadas à notícia
                  </v-card-title>
                  <v-data-table
                    :headers="headersUnidade"
                    :items="unidadesVinculadas"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        large
                        color="success"
                        class="mr-2"
                        @click="loadUpUnidade(item)"
                      >
                        mdi-square-edit-outline
                      </v-icon>
                    </template>
                  </v-data-table>
                  <v-card-actions class="justify-end">
                    <v-btn
                      color="success"
                      class="ml-4 mb-2"
                      v-if="noticia.id"
                      @click="loadAddUnidade"
                    >
                      <v-icon left>
                        mdi-plus
                      </v-icon>
                      Add unidade
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-row class="mt-4">
        <v-col
          cols="12"
          md="10"
        >
          <v-btn
            color="success"
            class="ml-1 mr-4"
            v-if="mode === 'save'"
            @click.prevent="save"
          >
            <v-icon left>
              mdi-content-save-outline
            </v-icon>
            Salvar
          </v-btn>
          <v-btn
            color="success"
            class="ml-1 mr-4"
            v-if="mode === 'editar'"
            @click.prevent="save"
          >
            <v-icon left>
              mdi-content-save-edit-outline
            </v-icon>
            Atualizar
          </v-btn>
          <v-btn
            color="success"
            class="mr-4"
            v-if="mode === 'sincv'"
            @click="save"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Sincronizar vereadorsss
          </v-btn>
          <v-btn
            color="secondary"
            class="mr-4"
            @click="reset()"
          >
            <v-icon left>
              mdi-broom
            </v-icon>
            Limpar
          </v-btn>
          <v-btn
            v-if="noticia.id"
            color="error"
            class="mr-4"
            @click="remove"
          >
            <v-icon left>
              mdi-trash-can-outline
            </v-icon>
            Deletar
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar notícias
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="noticias"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click="loadUpdate(item)"
                    >
                      mdi-arrow-down-bold-box
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialogAnexo"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialogAnexo">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar anexos
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headersDoc"
                  :items="docs"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click="loadAddAnexo(item)"
                    >
                      mdi-arrow-down-bold-box
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialogAnexo.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="addGalery"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Criar galeris
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Galerias de fotos ou videos"
                  />
                  <v-form>
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="galeria.usuario"
                    />
                    <input
                      id="galeria-id"
                      type="hidden"
                      v-model="galeria.id"
                    />
                    <input
                      id="galeria-uuid"
                      type="hidden"
                      v-model="galeria.uuid"
                    />
                    <input
                      id="uid_noticia"
                      type="hidden"
                      v-model="galeria.uid_noticia"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="noticia.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="galeria.id"
                      >
                        <v-checkbox
                          v-model="galeria.inativar"
                          label="Inativar galeria?"
                          color="success"
                          class="mt-0 mb-2"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="5"
                      >
                        <v-autocomplete
                          v-model="galeria.uid_subcategoria"
                          :items="subcategorias"
                          required
                          dense
                          outlined
                          label="Subcategoria"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-autocomplete
                          v-model="galeria.tipo"
                          :items="tipoGaleria"
                          required
                          dense
                          outlined
                          label="Tipo de galeria"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-autocomplete
                          v-model="galeria.tipo"
                          :items="tipoGaleria"
                          required
                          dense
                          outlined
                          label="Mês"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="galeria.titulo"
                          label="Título da galeria"
                          outlined
                          required
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="galeria.subtitulo"
                          label="Subtítulo da galeria"
                          outlined
                          required
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="galeria.id"
                    @click.prevent="createGalery()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Atualizar
                  </v-btn>
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="!galeria.id"
                    @click.prevent="createGalery()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Criar
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                  <v-btn
                    v-if="galeria.id"
                    color="error"
                    class="mr-4"
                    @click="removeGalery"
                  >
                    <v-icon left>
                      mdi-trash-can-outline
                    </v-icon>
                    Deletar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog de adicionar categorias -->
      <v-container>
        <v-dialog
          v-model="dialogAddCategoria"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Categorias
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Categorias de notícia"
                  main=''
                  home=''
                />
                <form-cat
                  :categoria="categoria"
                  :mode="mode"
                />
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  type="submit"
                  @click.prevent="saveCat()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="closeDialogCategorias"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog de adicionar subcategoria de notícia -->
      <v-container>
        <v-dialog
          v-model="dialogAddSubCategoria"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Subcategorias
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Subcategorias de categorias de notícia"
                  main=''
                  home=''
                />
                <form-sub-cat
                  :subcategoria="subcategoria"
                  :mode="mode"
                />
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  type="submit"
                  @click.prevent="saveSubCat()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="closeDialogCategorias"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <!-- Dialog de adicionar imagem no site e slide -->
        <v-dialog
          v-model="dialogAddImg"
          transition="dialog-top-transition"
        >
          <v-card elevation="2">
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar imagens na capa e slide do site
            </v-toolbar>
            <v-card>
              <v-data-table
                :headers="headersFoto"
                :items="fotos"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:[`activator`]="{ on, attrs }">
                      <v-icon
                        large
                        color="success"
                        class="mr-2"
                        @click="addImagens(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-image-move
                      </v-icon>
                    </template>
                    <span>Adicionar imagem ao slide ou capa</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="closeDialogImg"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addFoto"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                <v-icon class="mr-2">mdi-pencil-box-outline</v-icon>Adicionar mídia à notícia
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <v-form>
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="foto.usuario"
                    />
                    <input
                      id="foto-id"
                      type="hidden"
                      v-model="foto.id"
                    />
                    <input
                      id="foto-uuid"
                      type="hidden"
                      v-model="foto.uuid"
                    />
                    <input
                      id="uid_boletim"
                      type="hidden"
                      v-model="foto.uuid_noticia"
                    />
                    <input
                      id="uid_boletim"
                      type="hidden"
                      v-model="foto.uid_noticia"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="noticia.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="foto.id"
                      >
                        <v-checkbox
                          v-model="foto.inativar"
                          label="Inativar Foto?"
                          color="success"
                          class="mt-0 mb-2"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="noticia.id"
                      >
                        <v-checkbox
                          v-model="foto.slide"
                          label="Imagem de slide ?"
                          color="success"
                          class="mt-0 mb-2"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="noticia.id"
                      >
                        <v-checkbox
                          v-model="foto.capa"
                          label="Imagem de capa ?"
                          color="success"
                          class="mt-0 mb-2"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="noticia.id"
                      >
                        <v-checkbox
                          v-model="foto.aviso"
                          label="Imagem do aviso ?"
                          color="success"
                          class="mt-0 mb-2"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="dtpub"
                              v-model="data_publicacao"
                              label="Data de publicação.:"
                              dense
                              outlined
                              @blur="mudaDataMidia"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date"
                            @input="dateF"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <input
                          accept="image/png, image/jpg, image/jpeg, image/bmp, image/webp, video/mp4, video/webm, video/ogg"
                          prepend-icon="mdi-camera"
                          label="Arquivo de imagem"
                          v-if="uploadReady"
                          type="file"
                          ref="file"
                          @change="selectFile()"
                        >
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="foto.imagem"
                          label="Nome da foto"
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="noticia.id"
                    type="submit"
                    @click.prevent="fileUpload()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="noticia.id"
                    @click="clearUpload"
                  >
                    Remover
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addDoc"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar arquivos anexo
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Adicionar ou editar documentos"
                  />
                  <v-form>
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="doc.usuario"
                    />
                    <input
                      id="doc-id"
                      type="hidden"
                      v-model="doc.id"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="codDocument"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="noticia.id"
                      >
                        <v-checkbox
                          v-model="doc.inativar"
                          label="Inativar arquivo?"
                          color="success"
                          class="mt-0 mb-2"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        lg="3"
                      >
                        <v-text-field
                          v-model="doc.nome"
                          label="Nome do documento"
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        colls="12"
                        lg="2"
                        md="3"
                      >
                        <v-autocomplete
                          label="Categoria do documento:"
                          v-model="doc.uid_tipodoc"
                          :items="tipoAnexo"
                          clearable
                          dense
                          outlined
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        colls="12"
                        lg="2"
                        md="2"
                      >
                        <v-autocomplete
                          label="Tipo de documento:"
                          v-model="doc.logodoc"
                          :items="tipoDoc"
                          clearable
                          dense
                          outlined
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="2"
                        md="2"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="dtpub"
                              v-model="data_publicacao"
                              label="Data de publicação.:"
                              dense
                              outlined
                              @blur="mudaDataMidia"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date"
                            @input="dateF"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <input
                        accept="application/vnd.ms-excel, application/vnd.ms-word, application/pdf"
                        prepend-icon="mdi-paperclip"
                        label="Documento"
                        v-if="uploadReady"
                        type="file"
                        ref="file"
                        @change="selectFile()"
                      >
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="noticia.id"
                    type="submit"
                    @click.prevent="anexoUpload()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar dc
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="noticia.id"
                    @click="clearUpload"
                  >
                    Remover
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="publicar"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Publicar conteúdo
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Publicar o conteúdo no site principal"
                  />
                  <v-form>
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="codigo"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="noticia.id"
                      >
                        <v-checkbox
                          v-model="noticia.publicar"
                          label="Publicar conteúdo?"
                          color="success"
                          class="mt-0 mb-2"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="dtpub"
                              v-model="data_publicacao"
                              label="Data de publicação.:"
                              dense
                              outlined
                              @blur="mudaDataMidia"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date"
                            @input="dateF"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="noticia.id"
                    type="submit"
                    @click="pubConteudo()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="noticia.id"
                    @click="resetNode"
                  >
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Adicionar vereador -->
      <v-container>
        <v-dialog
          v-model="dialogAddUnidade"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar ou editar unidade à notícia
            </v-toolbar>
            <v-card
              flat
              class="mt-10 mx-2"
            >
              <v-row>
                <input
                  type="hidden"
                  id="id-unidade"
                  v-model="unidade.id"
                >
                <input
                  type="hidden"
                  id="uid-noticia"
                  v-model="unidade.uid_noticia"
                >
                <input
                  type="hidden"
                  id="user"
                  v-model="unidade.usuario"
                >
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    v-model="unidade.uid_page"
                    :items="unidades"
                    clearable
                    required
                    dense
                    outlined
                    label="Unidade"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  v-if="unidade.id"
                  cols="12"
                  md="3"
                >
                  <v-checkbox
                    v-model="unidade.inativar"
                    label="Inativar unidade?"
                    color="success"
                    hide-details
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="!unidade.id"
                  @click.prevent="saveUnidade"
                >
                  <v-icon left>
                    mdi-content-save-outline
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="unidade.id"
                  @click.prevent="saveUnidade"
                >
                  <v-icon left>
                    mdi-content-save-edit-outline
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="secondary"
                  class="mr-4"
                  @click="resetUnidade()"
                >
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                  Limpar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="closeDialogUnidade()"
                >
                  Sair
                </v-btn>
                <v-btn
                  v-if="unidade.id"
                  color="error"
                  class="mr-4"
                  @click="removeUnidade"
                >
                  <v-icon left>
                    mdi-trash-can-outline
                  </v-icon>
                  Deletar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="editFoto"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                atualizar dados da imagem
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Atualizar dados da imagem"
                  />
                  <v-form>
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="noticia.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="noticia.id"
                      >
                        <v-checkbox
                          v-model="imagem.inativar"
                          label="inativar imagem?"
                          color="success"
                          class="mt-0 mb-2"
                        >
                        </v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="noticia.id"
                      >
                        <v-checkbox
                          v-model="imagem.capa"
                          label="Imagem de capa?"
                          color="success"
                          class="mt-0 mb-2"
                        >
                        </v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="noticia.id"
                      >
                        <v-checkbox
                          v-model="imagem.slide"
                          label="Imagem de slide?"
                          color="success"
                          class="mt-0 mb-2"
                        >
                        </v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-btn
                          color="success"
                          class="mr-4"
                          v-if="noticia.id"
                          @click="addImagemCapa()"
                        >
                          <v-icon left>
                            mdi-autorenew
                          </v-icon>
                          Sincronizar
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="dtpub"
                              v-model="data_publicacao"
                              label="Data de publicação.:"
                              dense
                              outlined
                              @blur="mudaDataMidia"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date"
                            @input="dateF"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="noticia.id"
                    type="submit"
                    @click="editImagem()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="noticia.id"
                    @click="resetImagem"
                  >
                    Desfazer
                    <v-icon left>
                      mdi-undo
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="vincFoto"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Vincular url à notícia
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Imagem de destaque"
                />
                <v-form>
                  <v-row>
                    <input
                      type="hidden"
                      id="id-image"
                      v-model="url.id"
                    >
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="imgSinc"
                        clearable
                        label="Url da foto"
                        outlined
                        required
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="noticia.id"
                        label="Código"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="noticia.id"
                    >
                      <v-checkbox
                        v-model="url.img_vinculada"
                        label="Vincular url?"
                        color="success"
                        class="mt-0 mb-2"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="noticia.id"
                    >
                      <v-checkbox
                        v-model="url.capa"
                        label="Foto da capa ?"
                        color="success"
                        class="mt-0 mb-2"
                        @click="capaImg"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="noticia.id"
                    >
                      <v-checkbox
                        v-model="url.slide"
                        label="Foto do slide ?"
                        color="success"
                        class="mt-0 mb-2"
                        @click="slideImg"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="noticia.id"
                    >
                      <v-checkbox
                        v-model="url.aviso"
                        label="Foto do aviso ?"
                        color="success"
                        class="mt-0 mb-2"
                        @click="avisoImg"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="noticia.id"
                  @click="addImagemCapa()"
                >
                  <v-icon left>
                    mdi-autorenew
                  </v-icon>
                  Sinconizar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="closeDialogUrl"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
import FormCat from '../forms/FormCat.vue'
import FormSubCat from '../forms/formSubCat.vue'
export default {
  name: 'NoticiaSite',
  components: { PageTitle, FormCat, FormSubCat },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    tp: '',
    box: '',
    fotoView: null,
    editor: ClassicEditor,
    editorConfig: {
    },
    imgSinc: null,
    dtpub: '##/##/####',
    tabs: null,
    isLoading: false,
    model: null,
    search: null,
    codigo: '',
    codDocument: '',
    dialog: false,
    dialogAnexo: false,
    addFoto: false,
    dialogAddImg: false,
    addGalery: false,
    dialogAddCategoria: false,
    dialogAddSubCategoria: false,
    addDoc: false,
    publicar: false,
    dialogAddVereador: false,
    dialogAddUnidade: false,
    editFoto: false,
    vincFoto: false,
    uploadReady: true,
    date: new Date().toISOString().substr(0, 10),
    data_publicacao: '',
    menu: false,
    file: '',
    tabela: 'imgnoticias',
    tabela1: 'imggaleria',
    tabela2: 'anexos',
    buscaCategoria: '',
    mode: 'save',
    noticia: {},
    unidade: {},
    not: {},
    noticias: [],
    publico: {},
    sync: {},
    categoria: {},
    categorias: [],
    subcategoria: {},
    subcategorias: [],
    unidades: [],
    unidadesVinculadas: [],
    galeria: {},
    foto: {},
    fotos: [],
    galerias: [],
    imagem: {},
    url: {},
    imagens: {},
    capaSlide: {},
    capa: {},
    doc: {},
    docs: [],
    anexo: {},
    anexos: [],
    tipoAnexo: [],
    length: '',
    tipoDoc: [
      { value: 'file-word-box', text: 'Word' },
      { value: 'file-excel-box', text: 'Excel' },
      { value: 'file-pdf-box', text: 'Pdf' }
    ],
    tipoGaleria: [
      { value: 'Fotos', text: 'Fotos' },
      { value: 'Videos', text: 'Videos' }
    ],
    targets: [
      { value: '_top', text: '_top' },
      { value: '_self', text: '_self' },
      { value: '_blank', text: '_blank' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Publicado', value: 'publicar', sortable: false },
      { text: 'Data publicação', value: 'data_publicacao' },
      { text: 'Imagem interna', value: 'img_vinculada', sortable: false },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersGaleria: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Tipo de galeria', value: 'tipo' },
      { text: 'Título', value: 'titulo' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersUnidade: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome da unidade', value: 'unidade' },
      { text: 'Título da notícia', value: 'titulo' },
      { text: 'Situação', value: 'inativar' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersFoto: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'imagem' },
      { text: 'Galeria', value: 'galeria' },
      { text: 'Capa', value: 'capaImg' },
      { text: 'Slide', value: 'slideImg' },
      { text: 'Aviso', value: 'avisoImg' },
      { text: 'Data', value: 'data' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAnexos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Url', value: 'url' },
      {
        text: 'Situação',
        value: 'situacao',
        sortable: false
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersDoc: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Url', value: 'url' },
      { text: 'Data', value: 'publicacao' },
      {
        text: 'Situação',
        value: 'situacao',
        sortable: false
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    capaImg () {
      if (this.imgSinc) {
        this.url.url_imagem = this.imgSinc
        this.url.url_slide = null
        this.url.url_aviso = null
      } else {
        this.url.url_imagem = null
      }
    },
    slideImg () {
      if (this.imgSinc) {
        this.url.url_slide = this.imgSinc
        this.url.url_imagem = null
        this.url.url_aviso = null
      } else {
        this.url.url_slide = null
      }
    },
    avisoImg () {
      if (this.imgSinc) {
        this.url.url_aviso = this.imgSinc
        this.url.url_imagem = null
        this.url.url_slide = null
      } else {
        this.url.url_aviso = null
      }
    },
    dateF () {
      this.data_publicacao = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaDataMidia () {
      const [dia, mes, ano] = this.data_publicacao.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    save () {
      const method = this.noticia.id ? 'put' : 'post'
      const id = this.noticia.id ? `/${this.noticia.id}` : ''
      axios[method](`${baseApiUrl}/noticias${id}`, this.noticia)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          if (!id) {
            this.reset()
            this.loadNoticia()
          } else {
            this.noticia = {}
            this.loadUpdate()
          }
        })
        .catch(showError)
    },
    loadAddAnexo (item) {
      const method = 'post'
      this.anexo.uid_anexo = item.id
      this.anexo.uid_usage = this.noticia.id
      this.anexo.usuario = this.user.id
      axios[method](`${baseApiUrl}/adicionar-anexo-na-noticia`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAnexos()
          this.closeDAnexo()
        })
        .catch(showError)
    },
    removeAnexo (item) {
      const id = item.id
      if (confirm('Deseja realmente remover este documento?')) {
        axios.delete(`${baseApiUrl}/remover-anexo-na-noticia/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadAnexos()
          })
          .catch(showError)
      }
    },
    pubConteudo () {
      this.publico.data_publicacao = this.date
      this.publico.publicar = this.noticia.publicar
      const id = this.noticia.uuid
      axios.put(`${baseApiUrl}/publicar-noticia/${id}`, this.publico)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetNode()
          this.loadUpdate()
          this.publicar = false
        })
        .catch(showError)
    },
    editImagem () {
      this.imagem.data_publicacao_img = this.date
      const id = this.foto.uuid
      axios.put(`${baseApiUrl}/editar-imagem/${id}`, this.imagem)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.foto = {}
          this.loadGalery()
          this.loadFotos()
          this.resetImagem()
          this.editFoto = false
        })
        .catch(showError)
    },
    createGalery () {
      const method = this.galeria.id ? 'put' : 'post'
      const id = this.galeria.id ? `/${this.galeria.id}` : ''
      axios[method](`${baseApiUrl}/galeria-da-noticia${id}`, this.galeria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.galeria = {}
          this.loadGalery()
        })
        .catch(showError)
    },
    removeGalery () {
      const id = this.galeria.id
      if (confirm('Deseja realmente remover a galeria da notícia?')) {
        axios.delete(`${baseApiUrl}/galeria-da-noticia/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadGalery()
          })
          .catch(showError)
      }
    },
    addImagemCapa () {
      const id = this.noticia.uuid
      this.url.uid_noticia = this.noticia.id
      axios.put(`${baseApiUrl}/update-de-noticia-e-img/${id}`, this.url)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUpdate()
        })
        .catch(showError)
    },
    addImagens (item) {
      if (this.box === 'slide') {
        this.imagens.slide = true
        this.imagens.url_slide = item.url
        this.imagens.uid_urlslide = item.id
      }
      if (this.box === 'capa') {
        this.imagens.capa = true
        this.imagens.url_imagem = item.url
        this.imagens.uid_urlimg = item.id
      }
      if (this.box === 'popup') {
        this.imagens.aviso = true
        this.imagens.url_aviso = item.url
        this.imagens.uid_urlaviso = item.id
      }
      const id = this.noticia.uuid
      this.imagens.id = item.id
      axios.put(`${baseApiUrl}/vincular-imagem-na-capa-e-slide/${id}`, this.imagens)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUpdate()
          this.closeDialogImg()
        })
        .catch(showError)
    },
    desvinculaImg () {
      const id = this.noticia.uuid
      alert('Deseja realmente desvincular a imagem ou video?')
      axios.put(`${baseApiUrl}/desvincular-imagem-na-capa-e-slide/${id}`, this.capaSlide)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUpdate()
          this.capaSlide = {}
        })
        .catch(showError)
    },
    // saveVereador () {
    //   const method = this.vereador.id ? 'put' : 'post'
    //   const id = this.vereador.id ? `/${this.vereador.id}` : ''
    //   axios[method](`${baseApiUrl}/vereadores-da-noticia${id}`, this.vereador)
    //     .then(() => {
    //       this.$toasted.global.defaultSuccess()
    //       this.vereador.uid_vereador = ''
    //       this.loadVereadoresVinculados()
    //     })
    //     .catch(showError)
    // },
    // removeVereador () {
    //   const id = this.vereador.id
    //   if (confirm('Deseja realmente remover o vereador da notícia?')) {
    //     axios.delete(`${baseApiUrl}/vereadores-da-noticia/${id}`)
    //       .then(() => {
    //         this.$toasted.global.defaultSuccess()
    //         this.loadUnidadesViculadas()
    //       })
    //       .catch(showError)
    //   }
    // },
    saveUnidade () {
      const method = this.unidade.id ? 'put' : 'post'
      const id = this.unidade.id ? `/${this.unidade.id}` : ''
      axios[method](`${baseApiUrl}/unidade-da-noticia${id}`, this.unidade)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.unidade.uid_unidade = ''
          this.loadUnidadesViculadas()
        })
        .catch(showError)
    },
    removeUnidade () {
      const id = this.unidade.id
      if (confirm('Deseja realmente remover a unidade da notícia?')) {
        axios.delete(`${baseApiUrl}/unidadees-da-noticia/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadUnidadesViculadas()
          })
          .catch(showError)
      }
    },
    remove () {
      const id = this.noticia.id
      if (confirm('Deseja realmente deletar esta notícia?')) {
        axios.delete(`${baseApiUrl}/noticias/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },

    syncDados () {
      const method = 'post'
      axios[method](`${baseApiUrl}/noticias/sync-index`, this.sync)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },

    saveCat () {
      const method = this.categoria.id ? 'put' : 'post'
      const id = this.categoria.id ? `/${this.categoria.id}` : ''
      axios[method](`${baseApiUrl}/categorias${id}`, this.categoria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetCat()
          this.loadCategorias()
        })
        .catch(showError)
    },
    saveSubCat () {
      const method = this.subcategoria.id ? 'put' : 'post'
      const id = this.subcategoria.id ? `/${this.subcategoria.id}` : ''
      axios[method](`${baseApiUrl}/subcategorias${id}`, this.subcategoria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetSubCat()
          this.loadSubCategorias()
        })
        .catch(showError)
    },
    // selectFile () {
    //   this.file = this.$refs.file.files[0]

    // },
    selectFile () {
    const file = this.$refs.file.files[0]
      if (!file) return

      const tiposPermitidos = [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/bmp',
        'image/webp',
        'video/mp4',
        'video/webm',
        'video/ogg'
      ]

      if (!tiposPermitidos.includes(file.type)) {
        this.$toasted.error('Tipo de arquivo não permitido')
        this.$refs.file.value = ''
        return
      }

      this.file = file
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/imagem-da-noticia`
      formData.append('uuid', this.foto.uuid)
      formData.append('uuid_noticia', this.foto.uuid_noticia)
      formData.append('uid_noticia', this.foto.uid_noticia)
      formData.append('imagem', this.foto.imagem)
      formData.append('data_publicacao', this.date)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.foto.uid_noticia)
      // formData.append('tipoArquivo', this.file.type.startsWith('video') ? 'video' : 'imagem')
      formData.append('usuario', this.foto.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadGalery()
          this.resetUpload()
        })
        .catch(showError)
    },
    async anexoUpload () {
      const formData = new FormData()
      const method = this.doc.id ? 'put' : 'post'
      const id = this.doc.id ? `/${this.doc.id}` : ''
      const url = `${baseApiUrl}/upload-anexos-diversos${id}`
      formData.append('nome', this.doc.nome)
      formData.append('uid_tipodoc', this.doc.uid_tipodoc)
      formData.append('logodoc', this.doc.logodoc)
      formData.append('tabela', this.tabela2)
      formData.append('data_publicacao', this.date)
      formData.append('usuario', this.doc.usuario)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    async fileUploadGalery () {
      const formData = new FormData()
      const url = `${baseApiUrl}/imagem-da-galeria`
      formData.append('uuid', this.foto.uuid)
      formData.append('uuid_galeria', this.foto.uuid_galeria)
      formData.append('uid_galeria', this.foto.uid_galeria)
      formData.append('data_publicacao', this.date)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.foto.uid_noticia)
      formData.append('usuario', this.foto.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadGalery()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.foto = {}
      this.foto.uuid = uuid.v1()
      this.foto.usuario = this.user.id
      this.foto.uuid_galeria = this.galeria.uuid
      this.foto.uid_galeria = this.galeria.id
      this.foto.uuid_noticia = this.noticia.uuid
      this.foto.uid_noticia = this.noticia.id
      this.doc = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    loadNoticias () {
      const url = `${baseApiUrl}/noticias`
      axios.get(url).then(res => {
        this.noticias = res.data
      })
    },
    loadGalery () {
      const idB = this.noticia.id
      const url = `${baseApiUrl}/galerias-de-noticia-uid/${idB}`
      axios.get(url).then(res => {
        this.galerias = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadFotos () {
      const idB = this.noticia.id
      const url = `${baseApiUrl}/fotos-da-noticia/${idB}`
      axios.get(url).then(res => {
        this.fotos = res.data.map(item => {
          return {
            ...item,
            data: moment(item.data_publicacao).format('DD/MM/YYYY'),
            inativar: item.inativar === 0 ? 'Ativo' : 'Inativa',
            galeria: item.vinc_galeria === 0 ? 'Não' : 'Sim',
            capaImg: item.capa === 0 ? 'Não' : 'Sim',
            slideImg: item.slide === 0 ? 'Não' : 'Sim',
            avisoImg: item.aviso === 0 ? 'Não' : 'Sim'
          }
        })
      })
    },
    verFoto (tp) {
      if (tp === 'slide') {
        this.fotoView = this.noticia.url_slide
      } else if (tp === 'capa') {
        this.fotoView = this.noticia.url_imagem
      } else if (tp === 'video') {
        this.fotoView = this.noticia.url_Thumbnail
      } else if (tp === 'popup') {
        this.fotoView = this.noticia.url_aviso
      } else {
        this.fotoView = null
      }
    },
    loadDocuments () {
      const url = `${baseApiUrl}/anexos-diversos`
      axios.get(url).then(res => {
        this.docs = res.data.map(item => {
          return {
            ...item,
            publicacao: moment(item.data_publicacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadAnexos () {
      const idB = this.noticia.id
      const url = `${baseApiUrl}/anexos-da-noticia/${idB}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadFtCategorias (listaCat = 'sim') {
      const sh = this.buscaCategoria || 0
      const url = `${baseApiUrl}/filtrar-categorias/${sh}`
      axios.get(url).then(res => {
        this.categorias = res.data
      })
      this.listaCat = listaCat
    },
    clearCat () {
      this.listaCat = ''
      this.buscaCategoria = ''
      this.categorias = []
    },
    loadFtCategoria () {

    },
    loadCategorias () {
      const url = `${baseApiUrl}/categorias`
      axios.get(url).then(res => {
        this.categorias = res.data.map(item => {
          return {
            value: item.id,
            text: item.ds_categoria
          }
        })
      })
    },
    loadSubCategorias () {
      const uid = this.noticia.uid_categoria
      const url = `${baseApiUrl}/subcategorias-da-categoria/${uid}`
      axios.get(url).then(res => {
        this.subcategorias = res.data.map(subcat => {
          return {
            value: subcat.id,
            text: subcat.ds_subcategoria
          }
        })
      })
    },
    limparBoxes () {
      this.noticia.uid_categoria = null
      this.noticia.uid_subcategoria = ''
      this.subcategorias = []
    },
    // loadVereadores () {
    //   const url = `${baseApiUrl}/vereadores`
    //   axios.get(url).then(res => {
    //     this.vereadores = res.data.map(item => {
    //       return {
    //         value: item.id,
    //         text: item.nome
    //       }
    //     })
    //   })
    // },
    // loadVereadoresVinculados () {
    //   const id = this.noticia.id
    //   const url = `${baseApiUrl}/vereadores-de-noticia-uid/${id}`
    //   axios.get(url).then(res => {
    //     this.vereadoresVinculados = res.data.map(item => {
    //       return {
    //         ...item,
    //         inativar: item.inativar === 0 ? 'Ativo' : 'Inativo'
    //       }
    //     })
    //   })
    // },
    loadUnidades () {
      const url = `${baseApiUrl}/unidades-para-noticia`
      axios.get(url).then(res => {
        this.unidades = res.data.map(item => {
          return {
            value: item.id,
            text: item.unidade
          }
        })
      })
    },
    loadUnidadesViculadas () {
      const id = this.noticia.id
      const url = `${baseApiUrl}/unidades-de-noticia-uid/${id}`
      axios.get(url).then(res => {
        this.unidadesVinculadas = res.data.map(item => {
          return {
            ...item,
            inativar: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadNoticia () {
      this.clearUpdate()
      const url = `${baseApiUrl}/noticias-first-update`
      axios.get(url).then(res => {
        this.noticia = res.data
        this.codigo = this.noticia.id
        const uidCat = this.noticia.uid_categoria
        this.loadSubCategorias(uidCat)
      })
      this.dialog = false
      this.mode = 'editar'
    },
    clearUpdate () {
      this.noticia = {}
      this.codigo = ''
      this.loadUser()
    },
    loadUpdate (item) {
      const codId = this.codigo ? this.codigo : item.id
      const url = `${baseApiUrl}/noticias-filtro-update/${codId}`
      this.clearUpdate()
      axios.get(url).then(res => {
        this.noticia = res.data
        this.codigo = this.noticia.id
        const uidCat = this.noticia.uid_categoria
        this.loadSubCategorias(uidCat)
      })
      this.mode = 'editar'
      this.box = ''
      this.dialog = false
    },
    loadDelCapa () {
      // this.capaSlide.uid_urlimg = ''
      this.capaSlide.url_imagem = ''
      this.capaSlide.id = this.noticia.uid_urlimg
      this.capaSlide.capa = false
      this.capaSlide.rmcapa = true
      this.desvinculaImg()
    },
    loadDelVideo () {
      // this.capaSlide.uid_urlimg = ''
      this.capaSlide.url_video = ''
      this.capaSlide.url_Thumbnail = ''
      this.capaSlide.id = this.noticia.uid_urlvid
      this.capaSlide.video = false
      this.capaSlide.rmvideo = true
      this.desvinculaImg()
    },
    loadDelSlide () {
      // this.capaSlide.uid_urlslide = ''
      this.capaSlide.url_slide = ''
      this.capaSlide.id = this.noticia.uid_urlslide
      this.capaSlide.slide = false
      this.capaSlide.rmslide = true
      this.desvinculaImg()
    },
    loadDelPopup () {
      // this.capaSlide.uid_urlaviso = ''
      this.capaSlide.url_aviso = ''
      this.capaSlide.id = this.noticia.uid_urlaviso
      this.capaSlide.aviso = false
      this.capaSlide.rmaviso = true
      this.desvinculaImg()
    },
    loadFoto (foto, mode = 'save') {
      this.mode = mode
      this.foto = { ...foto }
      this.imagem.inativar = this.foto.inativar
      this.imagem.omitir_titulo_slide = this.foto.omitir_titulo_slide
      this.imagem.capa = this.foto.capa
      this.imagem.data_publicacao_img = this.foto.data_publicacao
      this.dateF()
      this.editFoto = true
    },
    loadUrl (foto, mode = 'save') {
      this.mode = mode
      this.foto = { ...foto }
      this.imgSinc = this.foto.url
      this.url.id = this.foto.id
      this.url.img_vinculada = true
      this.url.slide = this.foto.slide
      this.url.capa = this.foto.capa
      this.url.aviso = this.foto.aviso
      this.vincFoto = true
    },
    closeDialogUrl () {
      this.vincFoto = false
      this.url = {}
    },
    resetImagem () {
      this.imagem.inativar = this.foto.inativar
      this.imagem.capa = this.foto.capa
      this.imagem.slide = this.foto.slide
      this.imagem.aviso = this.foto.aviso
    },
    loadGalerias () {
      this.loadGalery()
    },
    loadMidias () {
      this.loadGalery()
      this.loadFotos()
    },
    loadDocs () {
      this.loadAnexos()
    },
    reset () {
      this.mode = 'save'
      this.fotoView = ''
      this.tp = ''
      this.img = null
      this.noticia = {}
      this.galeria = {}
      this.galerias = []
      this.unidade = {}
      this.unidadesVinculadas = []
      this.foto = {}
      this.fotos = []
      this.codigo = ''
      this.box = ''
      this.capaSlide = {}
      this.loadUser()
      this.loadDatas()
    },
    resetCat () {
      this.categoria = {}
    },
    // resetVereador () {
    //   this.vereador = {}
    // },
    resetUnidade () {
      this.unidade = {}
    },
    resetSubCat () {
      this.subcategoria = {}
    },
    loadAddSubCategoria () {
      this.subcategoria.uuid = uuid.v1()
      this.subcategoria.usuario = this.user.id
      this.subcategoria.uid_categoria = this.noticia.uid_categoria
      this.dialogAddSubCategoria = true
    },
    dialogCategoria () {

    },
    loadAddCategoria () {
      this.categoria.uuid = uuid.v1()
      this.categoria.usuario = this.user.id
      this.dialogAddCategoria = true
    },
    closeDialogCategorias () {
      this.dialogAddCategoria = false
      this.dialogAddSubCategoria = false
    },
    loadDialog () {
      this.dialog = true
      this.loadNoticias()
      this.reset()
    },
    loadDAnexo () {
      this.dialogAnexo = true
      this.loadDocuments()
    },
    closeDAnexo () {
      this.dialogAnexo = false
    },
    loadAddFoto () {
      this.foto.uuid = uuid.v1()
      this.foto.usuario = this.user.id
      this.foto.uuid_noticia = this.noticia.uuid
      this.foto.uid_noticia = this.noticia.id
      this.dateF()
      this.addFoto = true
    },
    loadAddImg (box) {
      this.box = box
      this.dialogAddImg = true
      this.loadFotos()
    },

    closeDialogImg () {
      this.dialogAddImg = false
      this.imagens = {}
      this.box = ''
    },
    loadAddFotoGalery () {
      this.foto.uuid = uuid.v1()
      this.foto.usuario = this.user.id
      this.foto.uuid_galeria = this.galeria.uuid
      this.foto.uid_galeria = this.galeria.id
      this.dateF()
      this.addFoto = true
    },
    loadAddGalery () {
      this.galeria.uuid = uuid.v1()
      this.galeria.usuario = this.user.id
      this.galeria.uid_subcategoria = this.noticia.uid_subcategoria
      this.galeria.uid_noticia = this.noticia.id
      this.galeria.titulo = this.noticia.titulo
      this.galeria.subtitulo = this.noticia.subtitulo
      this.addGalery = true
    },
    loadGaleriaUp (item) {
      this.galeria = { ...item }
      this.addGalery = true
    },
    loadPageGalery (item) {
      this.$router.push({
        name: 'viewGalerias',
        params: { id: item.uuid }
      })
    },
    loadAddDoc () {
      this.doc.usuario = this.user.id
      this.codDocument = this.doc.id
      this.dateF()
      this.addDoc = true
      this.loadTipoAnexo()
    },
    loadTipoAnexo () {
      const url = `${baseApiUrl}/categoria-de-documentos`
      axios.get(url).then(res => {
        this.tipoAnexo = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.cat_doc}`
          }
        })
      })
    },
    resetNode () {
      this.mode = 'save'
      this.publico = {}
      this.loadDatas()
    },
    loadPubConteudo () {
      //    this.publico.usuario = this.user.id //implementar na auditoria
      //    this.publico.uid_noticia = this.noticia.uuid // implementar na auditoria
      this.dateF()
      this.publicar = true
    },
    // loadAddVereador () {
    //   this.vereador.uid_noticia = this.noticia.id
    //   this.vereador.usuario = this.user.id
    //   this.dialogAddVereador = true
    //   this.loadVereadores()
    // },
    // loadUpVereador (item) {
    //   const id = item.id
    //   const url = `${baseApiUrl}/vereadores-da-noticia/${id}`
    //   axios.get(url).then(res => {
    //     this.vereador = res.data
    //   })
    //   this.loadVereadores()
    //   this.dialogAddVereador = true
    // },
    // closeDialogVereador () {
    //   this.dialogAddVereador = false
    //   this.vereador = {}
    // },
    loadAddUnidade () {
      this.unidade.uid_noticia = this.noticia.id
      this.unidade.usuario = this.user.id
      this.dialogAddUnidade = true
      this.loadUnidades()
    },
    loadUpUnidade (item) {
      const id = item.id
      const url = `${baseApiUrl}/unidades-da-noticia/${id}`
      axios.get(url).then(res => {
        this.unidades = res.data
      })
      this.loadUnidades()
      this.dialogAddUnidade = true
    },
    closeDialogUnidade () {
      this.dialogAddUnidade = false
      this.unidade = {}
    },
    loadUser () {
      this.noticia.uuid = uuid.v1()
      this.noticia.usuario = this.user.id
      this.loadCategorias()
    },
    loadDatas () {
      const dataAgora = new Date().toISOString().substr(0, 10)
      this.data_publicacao = moment(dataAgora).format('DD/MM/YYYY')
      this.date = dataAgora
      this.noticia.usuario = this.user.id
    }
  },
  watch: {
    search (val) {
      if (val === null || val === '') return
      if (this.noticia.uid_categoria) {
        if (val === this.model.categoria) return
      }
      this.loadCategorias()
    }
  },
  created () {
    this.loadUser()
  }
}
</script>

<style scoped>
.container {
  width: 98% !important;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-left {
  margin-top: -8px !important;
  margin-right: -8px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -13px !important;
}
.btn-outer-right-1 {
  margin-top: -8px !important;
  margin-left: -12px !important;
  border-top: solid 1px #878f97 !important;
  border-right: solid 1px #878f97 !important;
  border-bottom: solid 1px #878f97 !important;
}
.v-size--default {
  height: 39px !important;
  min-width: 38px !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 0px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
</style>
